import SearchComponent from "../../../../components/reusables/searchComponent";
import { AiFillMinusCircle, AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import ModalInfo from "../../../../components/lib/modalInfo";
import { GrCircleQuestion } from "react-icons/gr";
import { useEffect, useState } from "react";
import ClientService from "../../../../rest/clientService";
import CategorySelect from "../../../../components/reusables/categorySelect";

const ComboRegisterFormStep2 = ({ formik }) => {
    const [preferences, setPreferences] = useState(null);

    useEffect(() => {
        ClientService.getClientAdminPreferences().then(setPreferences);
    }, []);

    const items = Array.isArray(formik.values.items)
        ? formik.values.items
        : [];

    const handleItemSelect = (ingredient) => {
        const type = ingredient.product_id ? "product" : "recipe";
        const itemId = String(
            ingredient.product_id ?? ingredient.recipe_id
        );

        const existingIndex = items.findIndex(
            i => i.item_id === itemId && i.type === type
        );

        if (existingIndex >= 0) {
            const updated = [...items];
            updated[existingIndex] = {
                ...updated[existingIndex],
                amount: updated[existingIndex].amount + 1
            };
            formik.setFieldValue("items", updated);
            return;
        }

        formik.setFieldValue("items", [
            ...items,
            {
                item_id: itemId,
                name: ingredient.name,
                amount: 1,
                type
            }
        ]);
    };

    const changeAmount = (target, operation) => {
        const updated = items.map(item => {
            if (
                item.item_id === target.item_id &&
                item.type === target.type
            ) {
                const amount =
                    operation === "plus"
                        ? item.amount + 1
                        : Math.max(1, item.amount - 1);

                return { ...item, amount };
            }
            return item;
        });

        formik.setFieldValue("items", updated);
    };

    const removeItem = (target) => {
        const filtered = items.filter(
            i =>
                !(
                    i.item_id === target.item_id &&
                    i.type === target.type
                )
        );

        formik.setFieldValue("items", filtered);
    };

    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            <div className="my-6">
                <label className="font-medium block mb-2">
                    Lista de Itens do Combo:
                </label>

                <SearchComponent
                    onIngredientSelect={handleItemSelect}
                    searchType="all"
                />

                <div className="mt-4 flex flex-col w-full text-sm border-2 border-slate-200 rounded max-h-60 overflow-y-auto bg-white">
                    {items.length > 0 ? (
                        items.map(item => (
                            <div
                                key={`${item.type}-${item.item_id}`}
                                className="flex items-center justify-between border-b border-slate-200 p-2"
                            >
                                <p className="font-medium flex-1">
                                    {item.name}
                                    <span className="ml-2 text-xs text-gray-400">
                                        ({item.type === "product" ? "Produto" : "Receita"})
                                    </span>
                                </p>

                                <div className="flex items-center gap-2 mr-4">
                                    <button
                                        type="button"
                                        onClick={() => changeAmount(item, "minus")}
                                        className="p-1 border rounded-full hover:bg-gray-100 disabled:opacity-30"
                                        disabled={item.amount <= 1}
                                    >
                                        <AiOutlineMinus />
                                    </button>

                                    <span className="w-8 text-center font-bold">
                                        {item.amount}
                                    </span>

                                    <button
                                        type="button"
                                        onClick={() => changeAmount(item, "plus")}
                                        className="p-1 border rounded-full hover:bg-gray-100"
                                    >
                                        <AiOutlinePlus />
                                    </button>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => removeItem(item)}
                                    className="text-red-500 hover:scale-110 transition-transform"
                                >
                                    <AiFillMinusCircle size={22} />
                                </button>
                            </div>
                        ))
                    ) : (
                        <p className="p-4 text-gray-500 italic text-center">
                            Nenhum item adicionado ao combo.
                        </p>
                    )}
                </div>
            </div>

            <label className="relative space-y-1">
                <p>Categoria</p>
                <CategorySelect
                    name="category"
                    value={formik.values.category}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    categories={preferences?.categories}
                />
                <p className={"text-red-500 text-xs font-medium min-h-[14px]"}>
                    {formik.touched.category && formik.errors.category}
                </p>
            </label>


            <label>
                <div className="flex items-center justify-between">
                    Descrição do Produto:
                    <ModalInfo
                        icon={<GrCircleQuestion />}
                        content="Descrição visível para os clientes no app e no painel."
                    />
                </div>

                <textarea
                    className={`block w-full px-3 py-1.5 text-base text-gray-700 border rounded
                    focus:border-blue-600 focus:outline-none`}
                    name="description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                />
            </label>

            <label>
                <div className="flex items-center justify-between">
                    Observações:
                    <ModalInfo
                        icon={<GrCircleQuestion />}
                        content="Observações visíveis apenas no painel administrativo."
                    />
                </div>

                <textarea
                    className={`block w-full px-3 py-1.5 text-base text-gray-700 border rounded
                    focus:border-blue-600 focus:outline-none`}
                    name="observations"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations}
                />
            </label>
        </div>
    );
};

export default ComboRegisterFormStep2;
